import { render, staticRenderFns } from "./ModalWhereUser.vue?vue&type=template&id=bd06cab4&scoped=true"
import script from "./ModalWhereUser.vue?vue&type=script&lang=js"
export * from "./ModalWhereUser.vue?vue&type=script&lang=js"
import style0 from "./ModalWhereUser.vue?vue&type=style&index=0&id=bd06cab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd06cab4",
  null
  
)

export default component.exports